import crypto from 'node:crypto';
import { binaryToHex, EcdsaSecp256r1, toUserId, } from '@streamr/utils';
export const AES_KEY_SIZE = 32; // 256 bits
const AES_STORE_HEAD = 'streamrtv-aesKey-';
const PRIVATE_KEY_STORE_HEAD = 'streamrtv-ethKey-';
export class KeyStore {
    static instance;
    userIdCache = new Map();
    privateKeyCache = new Map();
    aesKeyCache = new Map();
    constructor() {
        this.userIdCache = new Map();
    }
    static getInstance() {
        if (!KeyStore.instance) {
            KeyStore.instance = new KeyStore();
        }
        return KeyStore.instance;
    }
    hasAesKey(streamId) {
        if (this.aesKeyCache.has(streamId)) {
            return true;
        }
        return localStorage.getItem(AES_STORE_HEAD + streamId) !== null;
    }
    getAesKey(streamId) {
        if (this.aesKeyCache.has(streamId)) {
            return this.aesKeyCache.get(streamId) ?? '';
        }
        if (!this.hasAesKey(streamId)) {
            const aesKey = crypto.randomBytes(AES_KEY_SIZE);
            const hexKey = binaryToHex(aesKey);
            localStorage.setItem(AES_STORE_HEAD + streamId, hexKey);
            return hexKey;
        }
        const aesKey = (localStorage.getItem(AES_STORE_HEAD + streamId) ??
            '');
        this.aesKeyCache.set(streamId, aesKey);
        return aesKey;
    }
    hasPrivateKey(streamId) {
        if (this.privateKeyCache.has(streamId)) {
            return true;
        }
        return localStorage.getItem(PRIVATE_KEY_STORE_HEAD + streamId) !== null;
    }
    getPrivateKey(streamId) {
        if (this.privateKeyCache.has(streamId)) {
            return this.privateKeyCache.get(streamId) ?? '';
        }
        if (!this.hasPrivateKey(streamId)) {
            const signingUtil = new EcdsaSecp256r1();
            const keyPair = signingUtil.generateKeyPair();
            const privateKey = keyPair.privateKey;
            const hexKey = binaryToHex(privateKey);
            localStorage.setItem(PRIVATE_KEY_STORE_HEAD + streamId, hexKey);
            return hexKey;
        }
        const ethKey = (localStorage.getItem(PRIVATE_KEY_STORE_HEAD + streamId) ?? '');
        this.privateKeyCache.set(streamId, ethKey);
        return ethKey;
    }
    // TODO is this cache needed in practice? Maybe could remove this method?
    getUserId(streamId) {
        if (this.userIdCache.has(streamId)) {
            return (this.userIdCache.get(streamId) ?? '');
        }
        const privateKeyBuffer = Buffer.from(this.getPrivateKey(streamId), 'hex');
        const signingUtil = new EcdsaSecp256r1();
        const userIdRaw = signingUtil.getPublicKeyFromPrivateKey(privateKeyBuffer);
        const userId = toUserId(userIdRaw);
        this.userIdCache.set(streamId, userId);
        return userId;
    }
}
